import { transformRoute, useTranslate } from "helpers";
import { Button } from "ui/components/Button/Button";
import { ButtonLink } from "ui/components/Button/ButtonLink";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";
import { VehicleDriverHeaderProps } from "./types";

/** Akcije widgeta vozača — u zaglavlju kartice, kao kod dokumenata i troškova. */
const VehicleDriverHeader = ({ vehicleId, onAdd }: VehicleDriverHeaderProps) => {
  const { t } = useTranslate();

  return (
    <div className="flex items-center gap-2">
      <ButtonLink
        size="small"
        variant="warning"
        children={t("admin.fleet.vehicle.driver.detail")}
        to={transformRoute(FleetVehicleRoutes.FleetVehicleDriverSearchPageRouter, {
          id: vehicleId,
        })}
        startIcon="/media/icons/search.svg"
      />
      <Button
        size="small"
        variant="secondary"
        startIcon="/media/icons/plus.svg"
        onClick={onAdd}
      >
        {t("admin.fleet.vehicle.driver.add")}
      </Button>
    </div>
  );
};

export default VehicleDriverHeader;
